<template>
  <div class="user-card">
    <div class="link-content">
      <div class="link-logout flex-middle" @click="logout">
        <img src="../../assets/img/user-card/mine_top_tuichu.png" />
        <!-- <a href="/api/user/logout" @click.self="toLogout">退出</a> -->
        <div class="logout-btn">{{ $t("user.logout") }}</div>
      </div>
      <div class="user-avatar-content flex-column flex-middle-only">
        <img
          v-if="userInfo.id"
          :src="userInfo.avatar || defaultAvatar"
          class="user-avatar"
          @error="onAvatarError"
        />
        <div class="flex-middle-only" style="font-size: 0.14rem; color: #333; font-weight: 500; margin-left: 0.04rem">
          {{ userInfo.nick_name }}
          <!-- <img class="level-icon" :src="userLevel(userInfo.level)" alt="" /> -->
          <span class="level" :style="levelToBg(userInfo.level)" style="background-size: 100% 100%;">&nbsp;</span>
        </div>
        <div class="name_id">{{ $t("user-center.id") }} {{ userInfo.id }}</div>
      </div>
      <div class="user-level-progress flex-row flex-middle">
        <div class="level-content">VIP-{{ userInfo.level?.toString().padStart(2, "0") }}</div>
        <el-progress class="flex-1" :text-inside="true" :stroke-width="15" :percentage="percentage || 0"></el-progress>
        <div class="level-content">VIP-{{ (userInfo.level + 1).toString().padStart(2, "0") }}</div>
      </div>
      <div class="flex-between flex-middle-only my-wallet">
        <span class="my_wallet_text" style="margin-left: 0.1rem;">{{ $t("user.wallet") }}</span>
        <div class="flex-middle-only my_kl_yz">
          <img style="width: 0.16rem; margin-right: 0.03rem" src="@/assets/img/icon/diamond.png" alt="" />
          {{ $t("user.gems") + " " + $bigNumber(userInfo.diamond / 100) }}
          <span class="line"></span>
          <img style="width: 0.16rem; margin-right: 0.03rem" src="@/assets/img/icon/gold.png" alt="" />
          {{ $t("user.diamonds") + " " + $bigNumber(userInfo.gold / 100) }}
        </div>

        <!-- <div v-show="appConfig.private_message_toggle || isSem === 0" class="recharge-btn" @click="recharge">{{ $t("user.recharge") }}</div> -->
      </div>

      <el-row class="bottom-tab-content flex-middle-only">
        <el-col :span="8">
          <router-link to="/user-center/index" class="flex-column flex-middle">
            <img src="../../assets/img/user-card/mine_nav_ziliao_on.png" />
            <span class="user-size">
              {{ $t("header.personal-center") }}
            </span>
          </router-link>
        </el-col>
        <el-col :span="8">
          <router-link to="/user-center/focus" class="flex-column flex-middle">
            <img src="../../assets/img/user-card/mine_nav_guanzhu_on.png" />
            <span class="user-size">
              {{ $t("user-tab.my-followed") }}
            </span>
          </router-link>
        </el-col>
        <el-col :span="8" class="flex-column flex-middle live" @click.native="startLive()">
          <img :src="isLiving ? require('@/assets/img/user-card/mine_nav_kaibo_on.png') : require('@/assets/img/user-card/mine_nav_kaibo.png')" />
          <span class="user-size">{{ isLiving ? $t("header.live") : $t("header.start-live") }}</span>
        </el-col>
        <el-col :span="8" v-if="this.appConfig.ticket_switch ==1">
          <router-link to="/user-center/voucher" class="flex-column flex-middle">
            <img src="../../assets/img/user-card/voucher.png" />
            <span class="user-size">
              {{ ticket }}张观赛券
            </span>
          </router-link>
        </el-col>
        <!-- <el-col :span="6">
          <router-link to="/user-center/privateChat" class="flex-column flex-middle private">
            <img src="../../assets/img/user-card/private-chat.png" />
            <span class="user-size">聊天消息</span>
            <span class="note" v-show="unreadTotal">{{ unreadTotal }}</span>
          </router-link>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { post } from "../../util/http";
import { userLevel } from "@/util/level-icon";
import { levelToBg } from "@/util/fontColorToLinearGradient";
import { clearTimUserSigCache } from "@/util/tim";
export default {
  props: {
    isLiving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      language: localStorage.getItem("language"),
      isSem: IS_SEM,
    };
  },
  computed: {
    ...mapState(["userInfo", "ticket", "appConfig", "defaultAvatar"]),
    ...mapGetters(["unreadTotal"]),
    percentage() {
      return this.userInfo.remainder + this.userInfo.process == 0 ? 0 : Math.round((this.userInfo.process / (this.userInfo.remainder + this.userInfo.process)).toFixed(2) * 100);
    },
  },
  mounted() {},
  methods: {
    ...mapMutations(["changeUserInfo", "toggleLiveLogout"]),
    ...mapActions(["toLogout"]),
    userLevel,
    levelToBg,
    onAvatarError(e) {
      if (e?.target && e.target.src !== this.defaultAvatar) {
        e.target.src = this.defaultAvatar;
      }
    },
    recharge() {
      this.$router.push("/user-center/recharge");
    },

    startLive() {
      console.log("startLive");
      this.$emit("startLive");
    },

    async logout() {
      const {
        data: { status },
      } = await post({
        url: "/api/user/logout",
      });
      if (status === 0) {
        // this.$store.commit("setIsLiving", false);
        // 先清 TIM sig 缓存，避免退出后 session 里残留账号被游客复用
        clearTimUserSigCache();
        localStorage.clear();
        // this.changeUserInfo({ id: "", diamond: 0, gold: 0 });
        // this.$router.push({ path: "/" });
        location.reload();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  clear: both;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .link-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    clear: both;
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 0.05rem;
    position: relative;
  }
.name_id {
            font-size: 12 * 0.01rem;
            color: #666666;
            margin-top: 8 * 0.01rem;
          }
  .user-avatar-content {
    margin-top: 0.3rem;
    .level-icon {
      height: 0.18rem;
      margin-left: 0.03rem;
    }
    .level {
        display: inline-block;
        width: 0.4rem;
        height: 0.18rem;
        line-height: 0.19rem;
        text-align: center;
        margin-left: 0.08rem;
        // background: linear-gradient(180deg, #ffa000 0%, #ffe600 100%);
        border-radius: 0.02rem;
        color: #ffffff;
        font-size: 0.12rem;
        margin-right: 0.04rem;
        // transform: scale(0.8);
        // vertical-align: middle;
        // background-size: 100%;
        // background-repeat: no-repeat;
      }
  }

  .user-avatar {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    margin-bottom: 0.1rem;
    background: #d8d8d8;
  }

  .user-level {
    position: relative;
    width: 0.5rem;
    height: 0.16rem;
    border-radius: 0.1rem;
    background-size: 100% 100%;
    color: #fff;
    font-size: 0.12rem;
    padding-right: 0.05rem;
    margin-left: 0.03rem;

    .text {
      background: linear-gradient(180deg, #ffffff 26.47%, rgba(255, 255, 255, 0.75) 76.47%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      text-shadow: 0px 1px 1px rgba(225, 27, 79, 0.1);
      transform: scale(0.8);
    }
  }

  .user-level-0 {
    background-image: url("~@/components/user-card/red_bar.png");
  }

  .user-level-1,
  .user-level-2,
  .user-level-3,
  .user-level-4,
  .user-level-5 {
    background-image: url("~@/components/user-card/red_bar.png");
  }

  .user-level-6,
  .user-level-7,
  .user-level-8,
  .user-level-9,
  .user-level-10 {
    background-image: url("~@/components/user-card/red_bar.png");
  }

  .user-level-11,
  .user-level-12,
  .user-level-13,
  .user-level-14,
  .user-level-15 {
    background-image: url("~@/components/user-card/red_bar.png");
  }

  .user-level-16,
  .user-level-17,
  .user-level-18,
  .user-level-19,
  .user-level-20,
  .user-level-21 {
    background-image: url("~@/components/user-card/red_bar.png");
  }

  .user-level-progress {
    padding: 0.1rem;

    .level-content {
      padding: 0 0.1rem;
      color: #333333;
      font-size: 0.12rem;
    }
  }

  ::v-deep .el-progress-bar__inner {
    //background-image: var(--theme-gradient);
    background-image: linear-gradient(90deg, #FF9500 0%, #FF0000 100%);
    .el-progress-bar__innerText {
        color: #FFFFFF !important;
    }
  }
  
  .recharge-btn {
    display: flex;
    width: 0.48rem;
    height: 0.21rem;
    line-height: 0.21rem;
    justify-content: center;
    background: var(--theme-primary);
    color: #fff;
    font-size: 0.12rem;
    border-radius: 0.15rem;
    cursor: pointer;
  }

  .link-logout {
    position: absolute;
    right: 0.1rem;
    top: 0.2rem;
    cursor: pointer;

    img {
      width: 0.19rem;
      height: 0.19rem;
    }

    .logout-btn {
      padding: 0 0.05rem;
      font-size: 0.14rem;
      color: #999999;
    }
  }

  .bottom-tab-content {
    //background: #f9f9fb;
    //background: rgba(41, 90, 255, 0.1);
    border-radius: 0 0 8px 8px;
    height: 0.8rem;
    margin-top: 0.2rem;
    color:#212121;
    .live {
      cursor: pointer;
    }
    .private {
      position: relative;
      cursor: pointer;
      .note {
        position: absolute;
        top: -0.08rem;
        right: 0.1rem;
        padding: 0 0.05rem;
        min-width: 0.1rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        border-radius: 0.2rem;
        background: #f64d5c;
        color: #ffffff;
        font-size: 0.12rem;
        margin-left: 0.06rem;
      }
    }

    img {
      width: 0.28rem;
      height: 0.28rem;
      margin-bottom: 0.06rem;
    }
  }

  .line {
    display: inline-block;
    width: 1px;
    height: 0.1rem;
    background: #dbdbdb;
    margin: 0 0.06rem;
  }

  .my-wallet {
    clear: both;
    width: 100%;
    overflow: hidden;
    font-size: 0.14rem;
    padding: 0px 0.08rem;
    color: #333;
    margin-top: 0.1rem;

    .my_wallet_text {
      flex-shrink: 0;
      display: block;
      width: 0.6rem;
      overflow: hidden;
      font-size: 0.14rem;
    }

    .my_kl_yz {
      width: 100%;
      overflow: hidden;
      font-size: 0.12rem;
      text-align: center;
    }
  }
}
</style>
